/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Amendment_Pending_Three_DaysInputs */

const en_orders_amendment_pending_three_days = /** @type {(inputs: Orders_Amendment_Pending_Three_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amendment Pending 3+ Days`)
};

const es_orders_amendment_pending_three_days = /** @type {(inputs: Orders_Amendment_Pending_Three_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enmienda pendiente 3+ dias`)
};

/**
* | output |
* | --- |
* | "Amendment Pending 3+ Days" |
*
* @param {Orders_Amendment_Pending_Three_DaysInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_amendment_pending_three_days = /** @type {((inputs?: Orders_Amendment_Pending_Three_DaysInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Amendment_Pending_Three_DaysInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_amendment_pending_three_days(inputs)
	return es_orders_amendment_pending_three_days(inputs)
});